import { fontSizes } from '../../constants/constants';
import CustomInput from '../../components/CustomInput';
import Text from '../../components/Text';
import Button from '../../components/Button';
import ViewItems from '../../components/ViewItems';
import ChooseApplicantTypeFunctional from './index.function';
import AuthWrapper from '../../components/AuthWrapper';
import { Formik } from 'formik';
import images from '../../constants/images';
import { Dropdown } from '../../components';
import {
  choose_applicanttype_schema,
  choose_applicanttype_validatiom_schema,
} from '../../validations_schemas/choose_applicanttype_validatiom_schema';
import { ReactSVG } from 'react-svg';
import icons from '../../constants/icons';
import { cn } from '../../utils/utils';
import { logoutUser } from '../../store/actions/authActions';
import { NafathModal } from '../WathqVerification/components';

const ChooseApplicantType = () => {
  const { TextWeight, authLoading, onsubmit, getContentKey, applicantTypes, navigate, isArabic, applicantLoading, closeModal, showModal, doneRef, nafath_code } =
    ChooseApplicantTypeFunctional();
  return (
    <AuthWrapper>
      <ViewItems className={`w-full`}>
        <ReactSVG src={icons.back} className={cn('cursor-pointer', isArabic ? 'rotate-180' : '')} onClick={() => navigate(-1)} />
        <img src={images.textLogo} width={70} className='mt-10' />

        <Formik
          validationSchema={choose_applicanttype_validatiom_schema}
          initialValues={choose_applicanttype_schema}
          validateOnChange={false}
          validateOnMount={false}
          validateOnBlur={false}
          onSubmit={(values) => onsubmit(values, false)}
          className='w-full'
        >
          {({ handleSubmit, setFieldValue, setFieldError, values, errors }) => {
            const isValid = values?.applicantType;
            return (
              <>
                <Text text={getContentKey('choose_applicant_type')} weight={TextWeight.semiBold} size={fontSizes.h18} className={'mb-5 mt-10'} />
                <>
                  <Dropdown
                    label={getContentKey('applicant_id_type')}
                    placeholder={getContentKey('applicant_type_placeholder')}
                    options={applicantTypes || []}
                    selectedValue={values?.applicantType}
                    valueKey={'name'}
                    isRequired={true}
                    onSelect={(val) => {
                      setFieldValue('applicantType', val);
                    }}
                    className={'mt-4'}
                  />
                  {values?.applicantType && (
                    <CustomInput
                      isRequired={true}
                      label={
                        values?.applicantType?.id?.toString() === '11'
                          ? getContentKey('national_id')
                          : values?.applicantType?.id?.toString() === '12'
                            ? getContentKey('iqama')
                            : getContentKey('passport_number')
                      }
                      maxLength={values?.applicantType?.id?.toString() === '11' || values?.applicantType?.id?.toString() === '12' ? 10 : 15}
                      value={values?.number}
                      onChange={(e) => {
                        setFieldValue('number', e.target.value);
                      }}
                      placeholder='12345676543'
                      divClasses={'mt-4'}
                      errorMessage={getContentKey(errors?.number)}
                    />
                  )}
                </>

                <ViewItems className={'w-full gap-1 mt-4'}>
                  <Button
                    text={getContentKey('verify')}
                    className={'mt-6 my-2 w-full'}
                    onClick={handleSubmit}
                    loading={authLoading}
                    type={'submit'}
                    isDisabled={!isValid}
                  />
                  <Button
                    text={getContentKey('sign_out')}
                    bgColor='bg-white'
                    color='text-primary'
                    type={'button'}
                    className={'w-full border border-primary'}
                    onClick={() => navigate('/login')}
                  />
                </ViewItems>

                <NafathModal
                  open={showModal}
                  onClose={closeModal}
                  nafath_code={nafath_code}
                  onTryAgain={() => {
                    doneRef.current = false;
                    onsubmit(values);
                  }}
                />
              </>
            );
          }}
        </Formik>
      </ViewItems>
    </AuthWrapper>
  );
};

export default ChooseApplicantType;
